module.exports = __webpack_public_path__ + "static/img/regisline.0276200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regisline.jpg
// module id = 369
// module chunks = 22